import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLocalized } from '../../utils/i18nHelpers';
import { getImageUrl } from '../../utils/imageHelpers';
import { FiArrowRight } from 'react-icons/fi';
import { FadeIn, SlideUp } from '../animations';

const StorySection = ({ settings }) => {
    const { i18n, t } = useTranslation();
    const defaultContent = {
        image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&q=70&w=800",
        subtitle: "ZAMANSIZ IŞILTI",
        title: "MASHOW PIRLANTA",
        desc: "Mashow Pırlanta Zarafeti, güveni ve kusursuz işçiliği bir araya getiren özel mücevher koleksiyonları.",
        link: "/about",
        linkText: "HİKAYEMİZİ KEŞFEDİN"
    };

    const content = settings?.storySection?.image ? settings.storySection : defaultContent;

    return (
        <section className="relative w-full py-1 bg-white mb-20">
            <div className="relative w-full h-[420px] md:h-[70vh] lg:h-[80vh] overflow-hidden">
                <img
                    src={getImageUrl(content.image) || content.image}
                    alt="Story"
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover object-center"
                />

                {/* Dark gradient for text readability */}
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />

                <div className="absolute top-1/2 left-4 md:left-24 lg:left-32 transform -translate-y-1/2 max-w-lg text-white">
                    <SlideUp delay={0.1}>
                        <span className="block text-[#45b59c] text-[10px] md:text-xs font-semibold tracking-[0.2em] uppercase mb-4">
                            {getLocalized(content, 'subtitle', i18n.language) || content.subtitle}
                        </span>
                    </SlideUp>
                    <SlideUp delay={0.2}>
                        <h2 className="text-3xl md:text-5xl lg:text-7xl font-serif mb-6 leading-tight whitespace-pre-line text-white">
                            {getLocalized(content, 'title', i18n.language) || content.title}
                        </h2>
                    </SlideUp>
                    <SlideUp delay={0.3}>
                        <p className="text-sm md:text-base font-light mb-8 text-white/80 max-w-sm">
                            {getLocalized(content, 'desc', i18n.language) || content.desc}
                        </p>
                    </SlideUp>
                    <FadeIn delay={0.5}>
                        <Link
                            to={content.link || "/about"}
                            className="inline-flex items-center gap-3 border border-white/50 text-white px-6 py-3 text-[10px] md:text-[11px] md:px-8 md:py-3 font-bold tracking-[0.2em] uppercase hover:bg-white hover:text-black transition-all duration-300"
                        >
                            {getLocalized(content, 'linkText', i18n.language) || content.linkText}
                            <FiArrowRight />
                        </Link>
                    </FadeIn>
                </div>
            </div>
        </section>
    );
};

export default StorySection;
